import { parseCookies } from 'nookies';

import { COOKIE_NAME_SALESPERSON, COOKIE_NAME_SALESPERSON_SLUG } from '@/constants/dealership/dealership.constants';
import { getConfigByFields } from '@/services/config.service';

/**
 * Injects LeadX source code into a lead payload if the salesperson cookie exists.
 */
export async function InjectLeadXSourceCode<T extends Record<string, any>>(leadData: T): Promise<T> {
  const cookiesData = parseCookies();
  const salespersonCookie = cookiesData[COOKIE_NAME_SALESPERSON_SLUG] || cookiesData[COOKIE_NAME_SALESPERSON];

  if (salespersonCookie) {
    try {
      const config = await getConfigByFields<{ leadx_source_code: string }>(['leadx_source_code']);

      if (config?.leadx_source_code) {
        (leadData as any).source = config.leadx_source_code;
      }
    } catch (error) {
      console.error('Error injecting LeadX source code:', error);
    }
  }

  return leadData;
}
